
const sponsorsData = [
    {
        name: "FeedIndia",
        logoUrl: "assets/images/home/sponsImages/feedindia.avif",
        websiteLink: "https://www.feedingindia.org/",
    },
    {
        name: "CEL",
        logoUrl: "assets/images/home/sponsImages/CEL.png",
        websiteLink: "/",
    },
    {
        name: "Gangesjute",
        logoUrl: "assets/images/home/sponsImages/Gangesjute.jpg",
        websiteLink: "https://https://www.gangesintl.com/",
    },
    {
        name: "IFEC",
        logoUrl: "assets/images/home/sponsImages/IFEC.JPG",
        websiteLink: "/",
    },
    {
        name: "Ketex",
        logoUrl: "assets/images/home/sponsImages/ketex.png",
        websiteLink: "https://ketex.com/",
    },
    {
        name: "Lepton",
        logoUrl: "assets/images/home/sponsImages/lepton.jpg",
        websiteLink: "/",
    },
    {
        name: "Telcon",
        logoUrl: "assets/images/home/sponsImages/Telcon.jpg",
        websiteLink: "/",
    },
];

const affiliationsData = [
    {
        name: "Amazon",
        logoUrl: "assets/images/home/sponsImages/Amazon.png",
        websiteLink: "https://amazon.care/",
    },
    {
        name: "Mathwork",
        logoUrl: "assets/images/home/sponsImages/mathwork.jpeg",
        websiteLink: "https://in.mathworks.com/",
    },
    {
        name: "IIC",
        logoUrl: "assets/images/home/sponsImages/IIC.JPG",
        websiteLink: "/",
    },
    {
        name: "TISS",
        logoUrl: "assets/images/home/sponsImages/TISS.png",
        websiteLink: "/",
    },
    {
        name: "NCC",
        logoUrl: "assets/images/home/sponsImages/NCC.png",
        websiteLink: "/",
    },
    {
        name: "NYKS",
        logoUrl: "assets/images/home/sponsImages/NYKS.jpg",
        websiteLink: "/",
    },
    {
        name: "Tiara",
        logoUrl: "assets/images/home/sponsImages/tiara.png",
        websiteLink: "/",
    },
];

export { sponsorsData, affiliationsData }